import { UserWallet } from './wallet';

let floatingInterval;
const userWallet = new UserWallet();

export async function initUserBalance() {
  userWallet.addObserver(updateUserBalance);
}

function updateUserBalance(userBalance) {
  if (!userBalance) return;

  let elList = document.querySelectorAll(
    '.js-cms-full-user-balance, .js-cms-user-balance, .js-cms-mixed-balance, .js-cms-bonus-balance, .js-cms-realbonus-balance'
  );
  for (let i = 0, len = elList.length; i < len; i++) {
    let el = elList[i],
      userBalancePart = '';
    if (el.classList.contains('js-cms-full-user-balance')) {
      if (userBalance.bonus_balance > 0) {
        userBalancePart = userBalance.balance + ' + ' + userBalance.bonus_balance;
      } else {
        userBalancePart = userBalance.balance;
      }
    } else if (el.classList.contains('js-cms-user-balance')) {
      userBalancePart = userBalance.balance;
    } else if (el.classList.contains('js-cms-mixed-balance')) {
      userBalancePart = userBalance.bonus_balance;
    } else if (el.classList.contains('js-cms-bonus-balance')) {
      userBalancePart = userBalance.bonus_part;
    } else if (el.classList.contains('js-cms-realbonus-balance')) {
      userBalancePart = userBalance.real_part;
    }
    createUserBalanceElement(el, userBalancePart, userBalance.currency);
    if (_CMS_MOBILE) {
      checkUserBalanceWidth();
    }
  }
}

function createUserBalanceElement(el, balance, currency) {
  el.innerHTML = balance + ' <span class="currency">' + currency + '</span>';
}

function checkUserBalanceWidth() {
  let userBalanceEl = document.querySelector('.nav .panel-user .js-cms-full-user-balance');
  userBalanceEl.classList.remove('floating');
  userBalanceEl.classList.remove('truncut');
  clearInterval(floatingInterval);
  if (userBalanceEl.scrollWidth > userBalanceEl.offsetWidth) {
    userBalanceEl.classList.add('truncut');
    if (userBalanceEl.scrollWidth > userBalanceEl.offsetWidth) {
      userBalanceEl.classList.remove('truncut');
      userBalanceEl.classList.add('floating');
      floatingInterval = setInterval(
        () => {
          if (userBalanceEl.style.left == '0px') {
            userBalanceEl.style.left = userBalanceEl.offsetWidth - userBalanceEl.scrollWidth + 'px';
          } else {
            userBalanceEl.style.left = '0px';
          }
        },
        parseFloat(getComputedStyle(userBalanceEl)['transitionDuration']) * 1000
      );
    }
  }
}
